<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="revalidarpractica" persistent max-width="330">
        <v-card>
          <v-card-title>Revalidar</v-card-title>
          <v-card-text
            >Esta seguro que desea revalidar la practica?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                Revalidar()
                confirmar = false
              "
              >Aceptar</v-btn
            >
            <v-btn color="red darken-1" text @click="revalidarpractica = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="confirmar" persistent max-width="330">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Esta seguro que desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                deleteItem()
                confirmar = false
              "
              >Aceptar</v-btn
            >
            <v-btn color="red darken-1" text @click="confirmar = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog
      v-if="autorizacion.Internaciones && autorizacion.Internaciones"
      v-model="cerrarinternacion"
      hide-overlay
      persistent
      width="500"
    >
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="cerrarinternacion = false">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <v-row>
            <v-col md="6">
              <v-text-field
                background-color="white"
                dense
                hide-details
                outlined
                label="Fecha de Cierre"
                v-model="autorizacion.Internaciones.fechacierre"
                type="date"
              >
              </v-text-field>
            </v-col>
            <v-col md="6">
              <cboMotivo
                v-model="autorizacion.Internaciones.id_motivocierre"
              ></cboMotivo>
            </v-col>
            <v-col md="12">
              <v-btn
                :disabled="
                  !autorizacion.Internaciones.fechacierre ||
                  !autorizacion.Internaciones.id_motivocierre
                "
                small
                color="primary"
                @click="cerrarlainternacion()"
              >
                Cerrar
              </v-btn>
              <v-btn
                class="mx-2"
                small
                color="red"
                @click="cancelarcerrarlainternacion()"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cambiarTipo" hide-overlay persistent width="500">
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="cambiarTipo = false">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <v-row>
            <v-col md="12">
              <h3>Tipo de autorizacion</h3>
              <v-select
                class="ml-2"
                background-color="grey lighten-3"
                v-model.number="autorizacion.tipo"
                :items="tipos"
                item-text="descripcion_tipo"
                item-value="id_tipo"
                label=""
                :return-object="false"
                hide-selected
                hide-details
                outlined
                dense
              ></v-select>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="cambiarTipo = false"
                  >Cerrar</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card :color="fondoEstado" v-if="!Loading" class="mt-6">
      <v-app-bar color="cyan lighten-4" dense elevation="0">
        <v-row align="center">
          <v-col md="12" class="d-inline-flex">
            <v-text-field
              background-color="grey lighten-3"
              dense
              hide-details
              outlined
              label=""
              :value="titulo"
              readonly
              style="max-width: 250px"
            >
            </v-text-field>

            <v-select
              class="ml-2"
              background-color="grey lighten-3"
              v-model.number="autorizacion.estado"
              :value="autorizacion.estado"
              :readonly="autorizacion.tipo == 4 || autorizacion.tipo == 6"
              :items="estados"
              item-text="descripcion_estado"
              item-value="id_estado"
              label="Estado"
              :return-object="false"
              hide-selected
              hide-details
              outlined
              dense
              style="max-width: 150px"
            >
            </v-select>
            <cboMotivoEstado
              :readonly="
                !auditoria || autorizacion.tipo == 4 || autorizacion.tipo == 6
              "
              class="ml-2"
              v-model="autorizacion.id_motivo"
              :id_estado="autorizacion.estado"
            ></cboMotivoEstado>
            <v-text-field
              v-if="autorizacion.tipo == 1"
              label="Coseguro"
              class="ml-2"
              background-color="grey lighten-3"
              dense
              readonly
              hide-details
              outlined
              :value="coseguro"
            ></v-text-field>
            <v-select
              v-if="autorizacion.tipo != 3 && 1 == 2"
              class="ml-2"
              background-color="grey lighten-3"
              v-model.number="autorizacion.id_area"
              :readonly="readonly"
              :items="areas"
              item-text="descripcion_area"
              item-value="id_area"
              label="Area"
              :return-object="false"
              hide-selected
              hide-details
              outlined
              dense
              style="max-width: 200px"
            >
            </v-select>
            <v-text-field
              label="Observacion"
              class="ml-2"
              background-color="grey lighten-3"
              v-if="!readonly"
              dense
              hide-details
              outlined
              v-model="nuevaObservacion"
              :clearable="!readonly && !soloderiva"
            ></v-text-field>
            <v-text-field
              label="Observacion Interna"
              class="ml-2"
              background-color="grey lighten-3"
              v-if="!readonly"
              dense
              hide-details
              outlined
              v-model="nuevaObservacionInterna"
              :clearable="!readonly && !soloderiva"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-app-bar>
      <v-card-text>
        <v-row>
          <v-col md="5">
            <v-card class="blue-grey lighten-5">
              <v-card-text>
                <v-row no-gutters>
                  <v-col
                    class="text-center"
                    v-if="!readonly || modificaInternacion"
                  >
                    <v-btn
                      v-if="!readonly || modificaInternacion"
                      small
                      color="green"
                      :disabled="guardarDisable()"
                      @click="Guardar()"
                    >
                      Guardar
                    </v-btn>

                    <div v-if="autorizacion.tipo == 5">
                      <h4 class="red--text" v-if="!OKImagenes()">
                        Imagenes Obligatorias
                      </h4>
                    </div>
                  </v-col>
                  <v-col
                    class="text-center"
                    v-if="!readonly || modificaInternacion"
                  >
                    <v-btn
                      v-if="!readonly || modificaInternacion"
                      small
                      color="blue"
                      :disabled="guardarDisable()"
                      @click="GuardarYsoltar()"
                    >
                      Guardar y Soltar
                    </v-btn>
                  </v-col>
                  <v-col class="text-center">
                    <v-btn small color="red" @click="Cancelar()">
                      Cancelar
                    </v-btn>
                  </v-col>
                  <v-col
                    class="text-center"
                    v-if="!readonly || modificaInternacion"
                  >
                    <v-btn
                      v-if="!readonly || modificaInternacion"
                      small
                      color="orange"
                      @click="Soltar()"
                    >
                      Soltar
                    </v-btn>
                  </v-col>
                  <v-col
                    class="text-center"
                    v-if="!readonly && autorizacion.estado == 2"
                  >
                    <v-btn
                      v-if="!readonly || modificaInternacion"
                      small
                      color="teal"
                      @click="revalidarpractica = true"
                    >
                      Revalidar
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <div v-if="autorizacion.tipo == 1">
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKFechaPrescripcion()"
                      >
                        * Error en la fecha de prescripcion 2
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKImagenes()"
                      >
                        Imagenes Obligatorias
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKPractica()"
                      >
                        * Error en la Práctica
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKEfector()"
                      >
                        * Error en el Prestador
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKDiagnostico()"
                      >
                        * Error en el Diagnostico
                      </span>
                    </div>
                    <div v-if="autorizacion.tipo == 2">
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKFechaPrescripcion()"
                      >
                        * Error en la fecha de prescripcion
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKFechaProgramada()"
                      >
                        * Error en la fecha programada
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKImagenes()"
                      >
                        Imagenes Obligatorias
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKPractica()"
                      >
                        * Error en la Práctica
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKEfector()"
                      >
                        * Error en el Prestador
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKDiagnostico()"
                      >
                        * Error en el Diagnostico
                      </span>
                    </div>
                    <div v-if="autorizacion.tipo == 3">
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKFechaInicio()"
                      >
                        * Error en la fecha de Inicio
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKFechaCierre()"
                      >
                        * Error en la fecha de Cierre
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKSector()"
                      >
                        * Error en el Sector
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKEfector()"
                      >
                        * Error en el Prestador
                      </span>
                      <span
                        class="red--text font-weight-bold"
                        v-if="!OKDiagnostico()"
                      >
                        * Error en el Diagnostico
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="5">
            <div v-if="usuarioAutoriza">
              <v-card class="my-1 light-blue lighten-4" elevation="4">
                <v-card-text>
                  <h3>Autorizada por {{ usuarioAutoriza.user_name }}</h3>
                  <h3 v-if="autorizacion.FechaRevalida">
                    Fecha Revalida: {{ autorizacion.FechaRevalida }}
                  </h3>
                </v-card-text>
              </v-card>
            </div>

            <desestimar
              v-model="autorizacion.desestimarpatologias"
              :patologias="autorizacion.Beneficiarios.PatologiasBeneficiarios"
            ></desestimar>
          </v-col>
          <v-col md="10">
            <v-row>
              <v-col md="6">
                <v-card v-if="autorizacion.internadoen" color="yellow">
                  <v-card-text>
                    <h3>Internado en: {{ autorizacion.internadoen }}</h3>
                  </v-card-text>
                </v-card>
                <v-card class="my-1 light-blue lighten-4" elevation="4">
                  <v-row>
                    <v-col>
                      <v-text-field
                        class="pl-3"
                        readonly
                        style="max-width: 220px"
                        type="date"
                        dense
                        hide-details
                        outlined
                        label="Fecha carga"
                        v-model="autorizacion.fecha"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4" class="light-blue lighten-4">
                      <v-checkbox
                        v-model="autorizacion.urgente"
                        label="Urgente"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col>
                      <h4>
                        Usuario carga:
                        <usuario
                          :id_usuario="autorizacion.id_usuario"
                        ></usuario>
                      </h4>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card class="m-1 teal lighten-4" elevation="4">
                  <v-row>
                    <v-col md="6" v-if="autorizacion.tipo == 2">
                      <v-text-field
                        class="pl-3"
                        :readonly="readonly || soloderiva"
                        style="max-width: 220px"
                        type="date"
                        dense
                        hide-details
                        outlined
                        label="Fecha Inicio Internación"
                        v-model="autorizacion.fechaprogramada"
                        :clearable="!readonly && !soloderiva"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col md="6" v-if="autorizacion.tipo != 3">
                      <v-text-field
                        class="pl-3"
                        :readonly="readonly || soloderiva"
                        style="max-width: 220px"
                        type="date"
                        dense
                        hide-details
                        outlined
                        label="Fecha Prescripcion"
                        v-model="autorizacion.fechaprescripcion"
                        :clearable="!readonly && !soloderiva"
                      >
                      </v-text-field>

                      <span v-if="!autorizacion.fechaprescripcion">
                        FECHA prescripcion INVALIDA
                      </span>
                    </v-col>
                    <v-col md="5" v-if="autorizacion.tipo == 3">
                      <v-text-field
                        class="pl-3"
                        :readonly="readonly || soloderiva"
                        style="max-width: 220px"
                        type="date"
                        dense
                        hide-details
                        outlined
                        label="Fecha Inicio"
                        v-model="autorizacion.Internaciones.fechainicio"
                        :clearable="!readonly && !soloderiva"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col md="2" v-if="autorizacion.tipo == 3">
                      <v-text-field
                        dense
                        hide-details
                        :readonly="readonly || soloderiva"
                        outlined
                        label="Días"
                        v-mask="'###'"
                        v-model.number="autorizacion.Internaciones.cantidadDias"
                      ></v-text-field>
                    </v-col>
                    <v-col md="5" v-if="autorizacion.tipo == 3">
                      <v-text-field
                        readonly
                        style="max-width: 220px"
                        type="date"
                        dense
                        hide-details
                        outlined
                        label="Fecha Cierre"
                        v-model="autorizacion.Internaciones.fechacierre"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col md="6" v-if="autorizacion.tipo == 3">
                      <cboMotivo
                        class="px-3"
                        readonly
                        v-model="autorizacion.Internaciones.id_motivocierre"
                      ></cboMotivo>
                    </v-col>
                    <v-col md="12" v-if="autorizacion.tipo == 3">
                      <cboSector
                        :readonly="readonly || soloderiva"
                        class="px-3"
                        v-model="autorizacion.Internaciones.id_sector"
                      >
                      </cboSector>
                    </v-col>
                    <v-col
                      md="12"
                      v-if="
                        autorizacion.tipo == 3 &&
                        ((!readonly &&
                          (!soloderiva || permisoCerrarInternacion)) ||
                          modificaInternacion)
                      "
                    >
                      <v-btn
                        class="mx-2"
                        small
                        color="primary"
                        @click="cerrarinternacion = true"
                      >
                        Cerrar Internacion
                      </v-btn>
                    </v-col>
                    <v-col md="12" v-if="autorizacion.tipo == 3">
                      <h4 class="px-3">Prorrogas</h4>
                      <prorroga
                        v-for="(prorr, index) in autorizacion.Internaciones
                          .Prorrogas"
                        :key="prorr.Id"
                        :evalua="auditoria"
                        :prorroga="prorr"
                        @updated="(v) => actualizarprorroga(index, v)"
                        @prorrogaeliminada="eliminarprorroga"
                        :readonly="readonly || soloderiva"
                      ></prorroga>
                    </v-col>
                    <v-col
                      md="12"
                      v-if="
                        autorizacion.tipo == 3 &&
                        ((!readonly && !soloderiva) || modificaInternacion)
                      "
                    >
                      <h4 class="px-3">Nueva</h4>
                      <prorroga
                        :evalua="auditoria"
                        alta
                        class="white"
                        :id_solic="autorizacion.id_solic"
                        @prorrogadadaalta="prorrogadadadealta"
                        v-if="autorizacion.tipo == 3"
                      ></prorroga>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card
                  v-if="
                    (autorizacion.fechaprescripcion &&
                      autorizacion.tipo != 5) ||
                    autorizacion.tipo == 3
                  "
                  class="my-1"
                  elevation="4"
                >
                  <v-col class="teal lighten-4">
                    Diagnostico:
                    <span class="pl-6" v-if="autorizacion.Diagnosticos">
                      {{ autorizacion.Diagnosticos.Problema }}
                      <v-btn icon v-if="!readonly && !soloderiva">
                        <v-icon
                          color="red"
                          @click="autorizacion.Diagnosticos = undefined"
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                  </v-col>
                  <v-card-text v-if="!autorizacion.Diagnosticos">
                    <v-row no-gutters>
                      <v-col md="6">
                        <AutocompletarDiagnostico
                          v-model="autorizacion.Diagnosticos"
                          v-if="!autorizacion.Diagnosticos"
                        ></AutocompletarDiagnostico>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card
                  class="my-1"
                  elevation="4"
                  v-if="
                    autorizacion.tipo != 3 &&
                    autorizacion.tipo != 4 &&
                    autorizacion.tipo != 5 &&
                    autorizacion.tipo != 6
                  "
                >
                  <v-col class="light-blue lighten-4">
                    Cantidad:
                    <input
                      :readonly="readonly || soloderiva"
                      type="text"
                      class="mx-2 px-1"
                      v-model.number="autorizacion.cantidad"
                      @blur="evaluarCantidad()"
                      style="
                        max-width: 35px;
                        direction: rtl;
                        background-color: white;
                        border-radius: 3px;
                      "
                    />
                    Práctica:
                    <span class="pl-1" v-if="autorizacion.baso001">
                      {{ autorizacion.baso001.cod_nom }} -
                      {{ autorizacion.baso001.des_nom.substring(0, 90) }}
                      <v-btn icon v-if="!readonly && !soloderiva">
                        <v-icon
                          color="red"
                          @click="
                            ;(autorizacion.baso001 = undefined),
                              (autorizacion.id_practica = undefined),
                              (autorizacion.cantidad = 1)
                          "
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                    <h4
                      class="red--text"
                      v-if="ultimavezpractica && autorizacion.baso001"
                    >
                      {{ ultimavezpractica }}
                    </h4>
                  </v-col>

                  <v-card-text v-if="!autorizacion.baso001">
                    <v-row no-gutters>
                      <v-col md="3">
                        <AutocompletarNomenclador
                          v-model="autorizacion.baso001"
                          v-if="!autorizacion.baso001"
                        ></AutocompletarNomenclador>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card
                  class="my-1"
                  elevation="4"
                  v-if="autorizacion.tipo == 4"
                >
                  <v-col class="light-blue lighten-4">
                    <AutocompletarLaboratorio
                      v-model="nuevo_labo"
                    ></AutocompletarLaboratorio>
                    Laboratorios:
                    <span
                      class="pl-1"
                      v-for="(
                        laboratorio, i
                      ) in autorizacion.Lineas_Laboratorio"
                      :key="laboratorio.id_linealaboratorio"
                    >
                      <linea
                        :readonly="!auditoria"
                        v-model="autorizacion.Lineas_Laboratorio[i]"
                      ></linea>
                      <v-btn icon v-if="!readonly && !soloderiva">
                        <v-icon
                          color="red"
                          @click="
                            eliminarLinea(laboratorio.id_linealaboratorio)
                          "
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                  </v-col>
                </v-card>
                <v-card
                  class="my-1"
                  elevation="4"
                  v-if="autorizacion.tipo == 6"
                >
                  <v-col class="light-blue lighten-4">
                    <AutocompletarLineas
                      v-model="nueva_linea"
                    ></AutocompletarLineas>
                    Practicas:
                    <span
                      class="pl-1"
                      v-for="(linea, i) in autorizacion.Lineas"
                      :key="linea.id_linea"
                    >
                      <span v-if="linea.estado != -1">
                        <linea
                          :readonly="!auditoria"
                          v-model="autorizacion.Lineas[i]"
                        ></linea>
                        <v-btn icon v-if="!readonly && !soloderiva">
                          <v-icon color="red" @click="linea.estado = -1">
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </span>
                    </span>
                  </v-col>
                </v-card>
              </v-col>
              <v-col md="6">
                <v-card
                  class="my-1"
                  elevation="4"
                  v-if="autorizacion.tipo != 5"
                >
                  <v-col class="light-blue lighten-4">
                    Prescriptor
                    <span class="pl-6" v-if="autorizacion.id_prescriptor">
                      {{ autorizacion.Prescriptor.nombreefector }} ({{
                        autorizacion.Prescriptor.RAZON_SOCI
                      }})
                      <v-btn icon v-if="!readonly && !soloderiva">
                        <v-icon
                          color="red"
                          @click="autorizacion.id_prescriptor = undefined"
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                  </v-col>
                  <v-card-text
                    v-if="
                      !autorizacion.id_prescriptor && !readonly && !soloderiva
                    "
                  >
                    <v-row no-gutters>
                      <v-col md="12">
                        <busquedaefector
                          v-model="autorizacion.Prescriptor"
                        ></busquedaefector>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card class="my-1" elevation="4">
                  <v-col
                    v-if="cambiosefector.length > 0"
                    class="teal lighten-4"
                    md="12"
                  >
                    <h4>Cambios</h4>

                    <v-data-table
                      :headers="headerscambiosefector"
                      :items="cambiosefector"
                      :items-per-page="5"
                      hide-default-footer
                      dense
                      class="elevation-1"
                    ></v-data-table>
                  </v-col>
                  <v-col class="teal lighten-4">
                    Prestador
                    <span v-if="!autorizacion.Efector">
                      <span class="pl-6" style="color: green"
                        >verde = pertenece al plan</span
                      >
                      <span class="pl-6" style="color: red"
                        >rojo = NO pertenece al plan</span
                      >
                    </span>
                    <span class="pl-6" v-if="autorizacion.Efector">
                      {{ autorizacion.Efector.nombreefector }} ({{
                        autorizacion.Efector.RAZON_SOCI
                      }})
                      <v-btn icon v-if="((!readonly && !soloderiva) || permisoCambiarPrestador)">
                        <v-icon
                          color="red"
                          @click="autorizacion.Efector = undefined"
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                    <domicilio
                      v-show="autorizacion.Efector"
                      :id_domicilio="autorizacion.id_domicilioprofesional"
                      :id_efector="autorizacion_efectorId"
                      v-model="autorizacion.id_domicilioprofesional"
                    ></domicilio>
                  </v-col>
                  <v-card-text v-if="!autorizacion.Efector">
                    <v-row no-gutters>
                      <v-col md="12">
                        <busquedaefector
                          auditoria
                          :id_plan="autorizacion.Beneficiarios.id_plan"
                          v-model="autorizacion.Efector"
                        ></busquedaefector>
                        <busquedaefectorProvincia
                          auditoria
                          :id_plan="autorizacion.Beneficiarios.id_plan"
                          v-model="autorizacion.Efector"
                        ></busquedaefectorProvincia>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="autorizacion.tipo == 2"
                  class="my-1"
                  elevation="4"
                >
                  <v-col class="teal lighten-4">
                    Prestador Profesional
                    <v-btn
                      v-if="!autorizacion.id_efectorprofesional"
                      color="primary"
                      x-small
                      @click="
                        autorizacion.EfectorProfesional = autorizacion.Efector
                      "
                    >
                      Copiar desde Prestador
                    </v-btn>
                    <span
                      class="pl-6"
                      v-if="autorizacion.id_efectorprofesional"
                    >
                      {{ autorizacion.EfectorProfesional.nombreefector }} ({{
                        autorizacion.EfectorProfesional.RAZON_SOCI
                      }})
                      <v-btn icon v-if="!readonly && !soloderiva">
                        <v-icon
                          color="red"
                          @click="
                            ;(autorizacion.EfectorProfesional = undefined),
                              (autorizacion.id_efectorprofesional = undefined)
                          "
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </span>
                  </v-col>
                  <v-card-text v-if="!autorizacion.EfectorProfesional">
                    <v-row no-gutters>
                      <v-col md="12">
                        <busquedaefector
                          v-model="efectorprofesional"
                        ></busquedaefector>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card
                  class="my-1 teal lighten-4"
                  elevation="4"
                  v-if="autorizacion.tipo == 5"
                >
                  <v-card-text>
                    <v-col class="">
                      <h4>Seleccionar Tipo</h4>
                      <v-btn small class="primary" @click="cambiarTipo = true"
                        >Tipo</v-btn
                      >
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <h4>Observaciones</h4>
                <v-data-table
                  v-if="observaciones.length > 0"
                  :headers="headersObservaciones"
                  :items="observaciones"
                  :items-per-page="5"
                  class="elevation-1"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="
                        comentariodelete = item
                        confirmar = true
                      "
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <span v-if="observaciones.length == 0">
                  <h3>Sin observaciones</h3>
                </span>
              </v-col>
              <v-col md="6" v-if="!autogestion">
                <h4>Observaciones Internas</h4>
                <v-data-table
                  v-if="observacionesinternas.length > 0"
                  :headers="headersObservaciones"
                  :items="observacionesinternas"
                  :items-per-page="5"
                  class="elevation-1"
                ></v-data-table>
                <span v-if="observacionesinternas.length == 0">
                  <h3>Sin observaciones Internas</h3>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="2" v-if="autorizacion.id_efector">
            <Imagenes
              :readonly="readonly && !modificaInternacion"
              :IdImagenes="autorizacion.idimagenes"
              @Upload="handleImageUploaded"
            ></Imagenes>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const ID_EFECTOR = process.env.VUE_APP_EFECTOR_POR_DEFECTO
import { mask } from 'vue-the-mask'

import AutocompletarDiagnostico from '@/components/Diagnostico/Autocompletar'
import AutocompletarNomenclador from '@/components/Nomenclador/Autocompletar'
import AutocompletarLaboratorio from '@/components/Lineas_Laboratorio/Autocompletar'
import AutocompletarLineas from '@/components/Lineas/Autocompletar'

import busquedaefector from '@/components/Efectores/Autocomplete'
import busquedaefectorProvincia from '@/components/Efectores/PorProvincia'
import Imagenes from '@/components/Practica/Imagenes'
import cboConvenio from '@/components/ConveniosPrestacionales/Combo'
import cboPlan from '@/components/Planes/Combo'
import cboSector from '@/components/Sectores/Combo'
import cboMotivo from '@/components/MotivosCierre/Combo'
import cboMotivoEstado from '@/components/Motivos/Combo'
import linea from '@/components/Lineas_Laboratorio/Linea'
import prorroga from '@/components/Practica/Prorroga'
import usuario from '@/components/Usuarios/TraerNombre'
import domicilio from '@/components/Efectores/Domicilios'
import desestimar from '@/components/Patologias/Desestimar'

import API from '../../lib/API'
import LUM from '@/lib/LUM'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  directives: { mask },
  components: {
    AutocompletarDiagnostico,
    AutocompletarNomenclador,
    AutocompletarLaboratorio,
    AutocompletarLineas,
    busquedaefector,
    busquedaefectorProvincia,
    Imagenes,
    cboPlan,
    cboConvenio,
    cboSector,
    cboMotivo,
    cboMotivoEstado,
    desestimar,
    domicilio,
    linea,
    prorroga,
    usuario
  },
  props: {
    solic: Object,
    patologias: Array,
    readonly: {
      type: Boolean,
      default: false
    },
    soloderiva: {
      type: Boolean,
      default: false
    },
    auditoria: {
      type: Boolean,
      default: false
    },
    autogestion: {
      type: Boolean,
      default: false
    },
    modificaInternacion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      revalidarpractica: false,
      prorrogaseliminadas: [],
      confirmar: false,
      comentariodelete: {},
      cambiosefector: [],
      ultimavezpractica: '',
      actualizarEstadolineas: true,
      nuevo_labo: null,
      nueva_linea: null,
      tipos: [],
      cambiarTipo: false,
      tab: null,
      Loading: false,
      cerrarinternacion: false,
      motivoEstado: '',
      diagnostico: undefined,
      practica: '',
      efector: undefined,
      prescriptor: undefined,
      efectorprofesional: undefined,
      nuevaObservacion: '',
      nuevaObservacionInterna: '',
      ObservacionesNuevas: [],
      idAreaOriginal: 0,
      id_linea: -9999,
      errores: {
        fechaprescripcion: ''
      },
      autorizacion: {
        id_solic: 0,
        id_afiliado: 0,
        fechaprescripcion: '',
        fechaprogramada: '',
        idproblema: 0,
        problema: '',
        id_practica: 0,
        cantidad: 1,
        id_efector: 0,
        id_efectorprofesional: 0,
        id_prescriptor: 0,
        tipo: 1,
        estado: 0,
        idimagenes: 0,
        Beneficiarios: {},
        id_domicilioprofesional: 0,
        id_motivo: 0
      },
      headersObservaciones: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Usuario', value: 'Usuarios.user_name' },
        { text: 'Observacion', value: 'observacion' },
        { text: 'Eliminar', value: 'actions' }
      ],
      headerscambiosefector: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Anterior', value: 'nombreEfectorAnterior' },
        { text: 'Nuevo', value: 'nombreEfectorNuevo' },
        { text: 'usuario', value: 'usuario' }
      ]
    }
  },
  asyncComputed: {
    coseguro: {
      get() {
        let idprac = 0
        let ret = 0
        if (
          this.autorizacion.tipo != 4 &&
          this.autorizacion.tipo != 2 &&
          this.autorizacion.tipo != 6
        ) {
          if (this.autorizacion.id_practica) {
            idprac = this.autorizacion.id_practica
          } else {
            if (this.autorizacion.baso001) {
              idprac = this.autorizacion.baso001.id
            }
          }
          let idafi = this.autorizacion.id_afiliado
          if (this.autorizacion.desestimarpatologias) {
            idafi = 0
          }
          if (
            this.autorizacion.id_afiliado &&
            this.autorizacion.cantidad &&
            idprac
          ) {
            ret = API.Autorizaciones.traerCoseguroPractica(
              idprac,
              idafi,
              this.autorizacion.FechaRevalida ? this.autorizacion.FechaRevalida : this.autorizacion.fecha,              
              this.autorizacion.cantidad
            ).then((response) => (ret = response))
          }
        }
        return ret
      }
    },
    usuarioAutoriza: {
      get() {
        let ret = 0
        ret = API.Tracking_Estados.traerUltimo(this.autorizacion.id_solic).then(
          (response) => (ret = response)
        )
        return ret
      }
    }
  },
  computed: {
    ...mapState('areas', { areas: 'Lista' }),
    ...mapState('imagenespracticas', { listadocumentos: 'Lista' }),
    ...mapGetters('comun', ['permisoCerrarInternacion', 'permisoCambiarPrestador']),
    autorizacion_estado() {
      if (this.autorizacion) {
        return this.autorizacion.estado
      }
    },
    estados() {
      if (this.auditoria) {
        return [
          { id_estado: 1, descripcion_estado: 'Pendiente' },
          { id_estado: 2, descripcion_estado: 'Autorizado' },
          { id_estado: 3, descripcion_estado: 'En Gestion' },
          { id_estado: 4, descripcion_estado: 'Rechazado' }
        ]
      } else if (
        !this.auditoria &&
        (this.autorizacion.estado == 1 || this.autorizacion.estado == 3)
      ) {
        return [
          { id_estado: 1, descripcion_estado: 'Pendiente' },
          { id_estado: 3, descripcion_estado: 'En Gestion' }
        ]
      } else {
        let est = [
          { id_estado: 1, descripcion_estado: 'Pendiente' },
          { id_estado: 2, descripcion_estado: 'Autorizado' },
          { id_estado: 3, descripcion_estado: 'En Gestion' },
          { id_estado: 4, descripcion_estado: 'Rechazado' }
        ]
        return est.filter((e) => e.id_estado === this.autorizacion.estado)
      }
    },
    autorizacion_efector() {
      if (this.autorizacion) {
        return this.autorizacion.Efector
      } else {
        return 0
      }
    },
    autorizacion_efectorId() {
      if (this.autorizacion) {
        if (this.autorizacion.Efector) {
          return this.autorizacion.Efector.Id
        }
      }
      return 0
    },
    autorizacion_baso001() {
      if (this.autorizacion) {
        return this.autorizacion.baso001
      }
    },
    titulo() {
      if (this.tipos.length > 1) {
        let ret = `#: ${this.autorizacion.id_solic}`
        let _tipos = this.tipos
        let tipo = _tipos.find(
          (x) => x.id_tipo == this.autorizacion.tipo
        ).descripcion_tipo
        return ret + ' - ' + tipo
      }
    },
    observaciones() {
      let ret = []
      if (this.autorizacion.Observaciones) {
        let obs = [...this.autorizacion.Observaciones]
        obs.sort(LUM.dynamicSort('-id'))
        ret = obs
      }
      return ret
    },
    observacionesinternas() {
      let ret = []
      if (this.autorizacion.ObservacionesInternas) {
        let obs = [...this.autorizacion.ObservacionesInternas]
        obs.sort(LUM.dynamicSort('-id'))
        ret = obs
      }
      return ret
    },
    fondoEstado() {
      let ret = 'lime lighten-4'
      switch (this.autorizacion.estado) {
        case 1:
          ret = 'red'
          break
        case 2:
          ret = 'green'
          break
        case 3:
          ret = 'orange lighten-1'
          break
        case 4:
          ret = 'black'
          break
        case 5:
          ret = 'white'
          break
        default:
          break
      }
      return ret
    },
    autorizacion_cantidad() {
      return this.autorizacion.cantidad
    },
    autorizacion_fechaprescripcion() {
      return this.autorizacion.fechaprescripcion
    },
    Lineas_Laboratorio() {
      return this.autorizacion.Lineas_Laboratorio
    },
    Lineas() {
      return this.autorizacion.Lineas
    },
    requiereImagen() {
      if (this.autorizacion) {
        return this.autorizacion.pideImagen
      }
      return false
    },
    tipo() {
      return this.autorizacion.tipo
    }
  },
  methods: {
    ...mapActions('autorizaciones', ['modificarEntidad']),
    ...mapActions('internaciones', ['modificarInternacion']),
    ...mapActions('lineaslaboratorio', { modificarlinea: 'guardarEntidad' }),
    ...mapActions('lineas', { modificarlineapractica: 'guardarEntidad' }),
    ...mapActions('prorrogas', { modificarprorroga: 'guardarEntidad' }),
    deleteItem() {
      API.Observaciones.eliminar(this.comentariodelete.id).then(() => {
        this.autorizacion.Observaciones.splice(
          this.observaciones.indexOf(this.comentariodelete),
          1
        )
      })
    },
    prorrogadadadealta(prorrogaalta) {
      delete prorrogaalta.Internaciones
      delete prorrogaalta.Usuarios
      this.autorizacion.Internaciones.Prorrogas.push(prorrogaalta)
    },
    eliminarprorroga(prorroga) {
      this.prorrogaseliminadas.push(prorroga.Id)
      this.autorizacion.Internaciones.Prorrogas =
        this.autorizacion.Internaciones.Prorrogas.filter(
          (x) => x.Id != prorroga.Id
        )
    },
    actualizarprorroga(index, laprorroga) {
      this.autorizacion.Internaciones.Prorrogas[index] = { ...laprorroga }
    },
    OKFechaPrescripcion() {
      let ret = true
      if (!this.autorizacion.fechaprescripcion) {
        console.warn('error en fecha de prescripcion')
        ret = false
      }
      return ret
    },
    OKFechaProgramada() {
      let ret = true
      if (!this.autorizacion.fechaprogramada) {
        console.warn('error en fecha programada')
        ret = false
      }
      return ret
    },
    OKImagenes() {
      let ret = true
      if (
        (this.requiereImagen && this.listadocumentos.length === 0) ||
        (this.autorizacion.tipo == 5 && this.listadocumentos.length === 0)
      ) {
        console.warn('error en Imagenes')
        ret = false
      }
      return ret
    },
    handleImageUploaded() {
      if (this.autorizacion.estado === 4) {
        this.autorizacion.estado = 3
        this.Guardar(true)
      }
    },
    OKPractica() {
      let ret = true

      if (!this.autorizacion.baso001) {
        console.warn('error en la practica')
        ret = false
      } else {
        if (this.autorizacion.baso001.id === 0) {
          console.warn('error en la practica')
          ret = false
        }
      }
      return ret
    },
    OKEfector() {
      let ret = true
      if (!this.autorizacion.Efector) {
        console.warn('error en el efector')
        ret = false
      }
      //  else {
      //   if (this.autorizacion.Efector.Id == ID_EFECTOR && autorizacion.Beneficiarios.id_plan != 5) {
      //     console.warn("error en el efector");
      //     ret = false;
      //   }
      // }
      return ret
    },
    OKDiagnostico() {
      let ret = true
      if (!this.autorizacion.Diagnosticos) {
        console.warn('error en el diagnostico')
        ret = false
      } else {
        if (this.autorizacion.Diagnosticos.IdProblema == 0) {
          console.warn('error en el diagnostico')
          ret = false
        }
      }
      return ret
    },
    OKFechaInicio() {
      let ret = true
      if (!this.autorizacion.Internaciones.fechainicio) {
        console.warn('error en fecha de inicio')
        ret = false
      }
      return ret
    },
    OKFechaCierre() {
      let ret = true
      if (this.autorizacion.Internaciones.fechacierre) {
        if (
          this.autorizacion.Internaciones.fechacierre <
          this.autorizacion.Internaciones.fechainicio
        ) {
          console.warn('error en fecha de cierre')
          ret = false
        }
      }
      return ret
    },
    OKSector() {
      let ret = true
      if (!this.autorizacion.Internaciones.id_sector) {
        console.warn('error en el sector')
        ret = false
      }
      return ret
    },
    async traercambiosefector() {
      this.cambiosefector = []
      for (const cambio of this.autorizacion.CambiosDeEfector) {
        let nuevo = await API.Efector.traerUno(cambio.idefectornuevo)
        let anterior = await API.Efector.traerUno(cambio.idefectoranterior)
        let usuario = await API.Usuarios.traerUno(cambio.id_usuario)
        this.cambiosefector.push({
          id: cambio.id,
          fecha: cambio.fecha,
          nombreEfectorNuevo: nuevo?.nombreefector,
          nombreEfectorAnterior: anterior?.nombreefector,
          usuario: usuario?.user_name
        })
      }
    },
    guardarDisable() {
      let ret = false
      let mot = ''
      switch (this.autorizacion.tipo) {
        case 1:
          if (
            !this.OKFechaPrescripcion() ||
            !this.OKImagenes() ||
            !this.OKPractica() ||
            !this.OKEfector() ||
            !this.OKDiagnostico()
          ) {
            if (this.requiereImagen && !this.listadocumentos) {
              mot += '* Imagen obligatoria'
            }
            ret = true
          }

          break
        case 2:
          if (
            !this.OKFechaPrescripcion() ||
            !this.OKFechaProgramada() ||
            !this.OKImagenes() ||
            !this.OKPractica() ||
            !this.OKEfector() ||
            !this.OKDiagnostico()
          ) {
            ret = true
          }
          break
        case 3:
          if (
            !this.OKFechaInicio() ||
            !this.OKFechaCierre() ||
            !this.OKSector() ||
            !this.OKEfector() ||
            !this.OKDiagnostico()
          ) {
            ret = true
          }
          break
        case 5:
          if (!this.OKImagenes()) {
            ret = true
          }
          break

        default:
          break
      }
      return ret
    },
    async traerTipos() {
      let _tipos = await API.Tipo_Autorizacion.Todos()
      this.tipos = _tipos
    },
    mds() {
      if (this.autorizacion.id_efector) {
        return 10
      }
      return 12
    },
    evaluarCantidad() {
      if (!this.autorizacion.cantidad) {
        this.autorizacion.cantidad = 1
      }
    },
    eliminarLinea(id_linea) {
      if (this.autorizacion.tipo == 6) {
        this.autorizacion.Lineas = this.autorizacion.Lineas.filter(
          (x) => x.id_linea != id_linea
        )
      } else {
        this.autorizacion.Lineas_Laboratorio =
          this.autorizacion.Lineas_Laboratorio.filter(
            (x) => x.id_linealaboratorio != id_linea
          )
      }
    },
    async Guardar(noemit = false) {
      this.Loading = true
      if (this.autorizacion.Diagnosticos) {
        this.autorizacion.idproblema = this.autorizacion.Diagnosticos.IdProblema
        this.autorizacion.problema = this.autorizacion.Diagnosticos.Problema
      }
      if (this.autorizacion.baso001) {
        this.autorizacion.id_practica = this.autorizacion.baso001.id
      }

      if (this.autorizacion.Efector) {
        this.autorizacion.id_efector = this.autorizacion.Efector.Id
      }
      if (this.autorizacion.EfectorProfesional) {
        this.autorizacion.id_efectorprofesional =
          this.autorizacion.EfectorProfesional.Id
      }
      if (this.autorizacion.Prescriptor) {
        this.autorizacion.id_prescriptor = this.autorizacion.Prescriptor.Id
      } else {
        this.autorizacion.id_prescriptor = undefined
      }

      let prac = { ...this.autorizacion }
      delete prac.Areas
      delete prac.Beneficiarios
      delete prac.Diagnosticos
      delete prac.Efector
      delete prac.EfectorProfesional
      delete prac.Prescriptor
      delete prac.baso001
      delete prac.Prescriptor
      delete prac.Derivaciones
      delete prac.Estados
      delete prac.Observaciones
      delete prac.ObservacionesInternas
      delete prac.Lineas_Laboratorio
      delete prac.Lineas
      delete prac.Usuarios
      delete prac.CambiosDeEfector
      delete prac.internadoen

      await this.modificarEntidad(prac)
      if (prac.tipo == 3) {
        if (prac.Internaciones) {
          for await (let prorr of prac.Internaciones.Prorrogas) {
            prorr = await this.modificarprorroga(prorr)
          }

          this.prorrogaseliminadas.forEach((id) => {
            API.Prorrogas.eliminar(id)
          })

          delete prac.Internaciones.Prorrogas
          await this.modificarInternacion(prac.Internaciones)
        }
      }
      delete prac.Internaciones
      if (this.autorizacion.Lineas_Laboratorio) {
        if (this.autorizacion.Lineas_Laboratorio.length > 0) {
          // this.autorizacion.Lineas_Laboratorio.forEach((x) => {
          //   if (x.id_linealaboratorio < 0) {
          //     x.baso001 = null
          //     x.id_linealaboratorio = 0
          //   }
          //    this.modificarlinea(x)
          // })
          for (
            let i = 0;
            i < this.autorizacion.Lineas_Laboratorio.length;
            i++
          ) {
            const x = this.autorizacion.Lineas_Laboratorio[i]
            if (x.id_linealaboratorio < 0) {
              x.baso001 = null
              x.id_linealaboratorio = 0
            }
            await this.modificarlinea(x)
          }
        }
      }
      if (this.autorizacion.Lineas) {
        if (this.autorizacion.Lineas.length > 0) {
          // for (let i = 0; i < this.autorizacion.Lineas.length; i++) {
          //   const x = this.autorizacion.Lineas[i]
          //   if (x.id_linea < 0) {
          //     x.baso001 = null
          //     x.id_linea = 0
          //   }
          //   await this.modificarlineapractica(x)
          // }
          const lineaseliminadas = []
          for (const linea of this.autorizacion.Lineas) {
            if (linea.id_linea < 0) {
              linea.baso001 = null
              linea.id_linea = 0
            }
            await this.modificarlineapractica(linea)
            if (linea.estado == -1) {
              lineaseliminadas.push(linea.id_linea)
            }
          }
          if (lineaseliminadas.length > 0) {
            // for (const id of lineaseliminadas) {
            //   this.eliminarLinea(id)
            // }
            for (let index = 0; index < lineaseliminadas.length; index++) {
              const element = lineaseliminadas[index]
              this.eliminarLinea(element)
            }
          }
          await API.Autorizaciones.calcularCoseguroLineas(prac.id_solic)
        }
      }
      if (this.autorizacion.id_area != this.idAreaOriginal) {
        this.Soltar()
      }
      if (this.nuevaObservacion) {
        let obs = await API.Observaciones.alta({
          id: 0,
          id_solic: prac.id_solic,
          observacion: this.nuevaObservacion,
          id_usuario: 0
        })

        this.autorizacion.Observaciones.push(obs)
      }
      if (this.nuevaObservacionInterna) {
        await API.ObservacionesInternas.alta({
          id: 0,
          id_solic: prac.id_solic,
          observacion: this.nuevaObservacionInterna,
          id_usuario: 0
        })
      }
      if (!noemit) {
        this.$emit('guardado')
      }
      this.Loading = false
    },
    Soltar() {
      API.AutorizacionesTomadas.soltar(this.autorizacion.id_solic)
      this.autorizacion.TomadaPor = 0
      this.$emit('guardado')
    },
    Revalidar() {
      API.Autorizaciones.revalidar(this.autorizacion.id_solic)
      this.$emit('guardado')
    },
    async GuardarYsoltar() {
      await this.Guardar()
      this.Soltar()
    },
    Cancelar() {
      this.$emit('guardado')
    },
    cerrarlainternacion() {
      this.modificarInternacion(this.autorizacion.Internaciones)
      this.cerrarinternacion = false
    },
    cancelarcerrarlainternacion() {
      this.autorizacion.Internaciones.fechacierre = ''
      this.cerrarinternacion = false
    },
    async establecerAutorizacion() {
      this.idAreaOriginal = this.solic.id_area
      this.autorizacion = {
        ...this.solic,
        Prescriptor: {},
        EfectorProfesional: {}
      }
      if (this.solic.id_prescriptor) {
        this.autorizacion.Prescriptor = await API.Efector.traerUno(
          this.solic.id_prescriptor
        )
      }
      if (this.solic.id_efectorprofesional) {
        this.autorizacion.EfectorProfesional = await API.Efector.traerUno(
          this.solic.id_efectorprofesional
        )
      }
    }
  },
  watch: {
    // autorizacion_estado() {
    //   if (this.actualizarEstadolineas == true) {
    //     if (this.autorizacion.Lineas_Laboratorio) {
    //       if (this.autorizacion.Lineas_Laboratorio.length > 0) {
    //         this.autorizacion.Lineas_Laboratorio.forEach((x) => {
    //           x.estado = this.autorizacion_estado;
    //         });
    //       }
    //     }
    //   }
    //   this.actualizarEstadolineas = true;
    // },
    nuevo_labo() {
      // console.warn(this.nuevo_labo)
      // console.warn(this.autorizacion.Lineas_Laboratorio)
      this.autorizacion.Lineas_Laboratorio.push({
        id_linealaboratorio: this.id_linea++,
        id_solic: this.autorizacion.id_solic,
        baso001: this.nuevo_labo,
        estado: 1,
        id_practica: this.nuevo_labo.id,
        practica: this.nuevo_labo
      })
    },
    async solic() {
      this.establecerAutorizacion()
    },
    tipo() {
      if (!this.autorizacion.Internaciones) {
        if (this.tipo == 3) {
          let inter = {
            id_solic: this.autorizacion.id_solic,
            fechainicio: '',
            id_sector: 1,
            fechacierre: ''
          }
          this.autorizacion.Internaciones = inter
        }
      }
    },
    Lineas_Laboratorio() {
      if (this.Lineas_Laboratorio.length > 0) {
        if (this.Lineas_Laboratorio.findIndex((x) => x.estado == 1) > -1) {
          this.autorizacion.estado = 1
        } else {
          if (this.Lineas_Laboratorio.findIndex((x) => x.estado == 3) > -1) {
            this.autorizacion.estado = 3
          } else {
            if (this.Lineas_Laboratorio.findIndex((x) => x.estado == 2) > -1) {
              this.autorizacion.estado = 2
            } else {
              this.autorizacion.estado = 4
            }
          }
        }
      }
    },
    Lineas() {
      if (this.Lineas.length > 0) {
        if (this.Lineas.findIndex((x) => x.estado == 1) > -1) {
          this.autorizacion.estado = 1
        } else {
          if (this.Lineas.findIndex((x) => x.estado == 3) > -1) {
            this.autorizacion.estado = 3
          } else {
            if (this.Lineas.findIndex((x) => x.estado == 2) > -1) {
              this.autorizacion.estado = 2
            } else {
              this.autorizacion.estado = 4
            }
          }
        }
      }
    },
    async autorizacion_baso001() {
      if (this.autorizacion_baso001) {
        let id_sol = this.autorizacion.id_solic
        this.ultimavezpractica = await API.Autorizaciones.ultimavez(
          id_sol,
          this.autorizacion.id_afiliado,
          this.autorizacion_baso001.id
        )
      } else {
        this.ultimavezpractica = ''
      }
    },
    autorizacion_efector() {
      if (!this.autorizacion_efector) {
        this.autorizacion.id_domicilioprofesional = 0
      }
    }
  },
  async mounted() {
    this.establecerAutorizacion()
    this.traerTipos()
    this.traercambiosefector()
  }
}
</script>

<style></style>
